"use client";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { Empty } from "antd";
import { Debug } from "@/util/debug";
import { checkNoItem, GetDataInputElement } from "./inputFunction";
import SkeletonInput from "antd/es/skeleton/Input";
import { useState } from "react";
import { Image } from "antd";
// import dynamic from "next/dynamic";
// const Image = dynamic(() => import("antd").then((mod) => mod.Image), { ssr: false });

export default function DataImage(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  //const placeholder = params.placeholder ?? params.defaultValue ?? params.value;
  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
  const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
  //Debug(params);
  const [error, setError] = useState(false);
  const getInput = () => {
    if (params.value && !error) {
      return (
        <Image
          src={params.value ?? ""}
          id={params.name}
          alt={params.name ?? ""}
          onError={() => {
            setError(true);
          }}
          className={params.inputClassName}
          {...params.imageProp}
        />
      );
    } else {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className={params.inputClassName} />;
    }
  };
  return (
    <>
      {prev}
      {unitPrev}
      {
        checkNoItem(params) ? getInput() : getInput()
        // <Form.Item name={params.name} noStyle valuePropName="checked">
        //   {getInput()}
        // </Form.Item>
      }
      {unit}
      {next}
    </>
  );
}
